import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { GLTF, GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

export class GltfLoader {
  private static _instance: GltfLoader = new GltfLoader();
  static get instance() {
    return this._instance;
  }

  private dracoLoader: any;
  private gltfLoader: any;

  constructor() {
    this.dracoLoader = new DRACOLoader();
    this.dracoLoader.setDecoderConfig({ type: 'js' });

    // Fetch Draco decoder from urls.
    this.dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');

    this.gltfLoader = new GLTFLoader();
    this.gltfLoader.setDRACOLoader(this.dracoLoader);
  }

  async loadGltf(glbBuffer: Buffer): Promise<GLTF> {
    return new Promise((resolve, reject) => {
      this.gltfLoader.parse(
        glbBuffer.buffer,
        '',
        (gltf: GLTF) => {
          resolve(gltf);
        },
        undefined,
      );
    });
  }
}
